module.exports = __webpack_public_path__ + "img/symbol_17.32f82795.png";